import { useRef, useMemo } from 'react';
import classes from 'features/realplays/Components/ReportResult/OldReportResult.module.css';
import PublicRealPlayHelper from 'features/publicRoleplay/publicRealPlay.helper';
import { InputSelect } from 'shared_ui_components';
import ScenarioContext from 'features/realplays/Components/ReportResult/ScenarioContext';
import RoleplayRecording from 'features/realplays/Components/ReportResult/RoleplayRecording';
import Strengths from 'features/realplays/Components/ReportResult/Strengths';
import Improvements from 'features/realplays/Components/ReportResult/Improvements';
import Feedback from 'features/realplays/Components/ReportResult/Feedback';
import Ratings from 'features/realplays/Components/ReportResult/Ratings';
import PublicTranscription from '../Common/PublicTranscription';
import User from 'infrastructure/User';

const OldViewResults = () => {
  const playerRef = useRef(null);
  const {
    videoURL,
    globalRatingCriteria,
    assignment_uuid,
    assigned_by_user,
    scenarios,
    scenariosLength,
    AIprospect,
    role,
    industry,
    situation,
    endDate,
    title,
    selectedScenario,
    rating_criteria,
    feedback,
    summary,
    setScenarioWithSelector,
  } = PublicRealPlayHelper();

  const handleSeek = (timestamp) => {
    const seconds = parseFloat(timestamp);
    const player = playerRef.current;
    if (player) {
      player.seekTo(seconds, 'seconds');
      player.getInternalPlayer()?.play?.();
    }
  };

  const options = useMemo(() => {
    if (!scenarios || scenarios?.length === 0) return [];
    return scenarios?.map((sc, i) => ({
      label: `${i + 1}. ${sc?.name}`,
      value: sc?.uuid,
    }));
  }, [scenarios]);

  const value = useMemo(() => {
    return (options ?? []).find((opt) => opt?.value === selectedScenario?.uuid);
  }, [options, selectedScenario]);

  const onSelectedValue = (value) => {
    const newList = {
      ...(scenarios ?? []).find((sce) => sce?.uuid === value),
      isRecording: false,
      tempVideoUrl: '',
    };
    setScenarioWithSelector(newList || {});
  };

  const formattedDate = () => {
    if (endDate) {
      const date = new Date(endDate);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Los meses empiezan en 0
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    }
    return formatDate();
  };
  const userName = User.getUserName(assigned_by_user);

  return (
    <div style={{ background: '#f3f5f8', height: '100%' }}>
      <div className={classes.headerContainer}>
        <div>
          <div>
            <div className={classes.header} style={{ marginLeft: '2.5rem' }}>
              <span className="heading4">
                Interactive Roleplay "{title}" {formattedDate()}
              </span>
            </div>
            {scenariosLength > 1 && (
              <div className={classes.scenarioSelector}>
                <InputSelect
                  value={value}
                  onChange={(opt) => onSelectedValue(opt?.value || '')}
                  options={options}
                  closeMenuOnSelect
                />
              </div>
            )}
          </div>
        </div>
      </div>
      <div className={classes.gridContainer} style={{ marginTop: "20px" }}>
        <div className={classes.left}>
          <ScenarioContext
            prospectName={AIprospect?.name}
            customer_role={role}
            customer_industry={industry}
            customer_situation={situation}
            selectedScenario={selectedScenario}
            scenarios={scenarios}
            title={title}
          />
          <RoleplayRecording videoURL={videoURL} playerRef={playerRef} />
          <Strengths summary={summary} handleSeek={handleSeek} />
          <Improvements summary={summary} />
        </div>
        <div className={classes.right}>
          {feedback === '' ? (
            <Feedback feedback={feedback} stillInProgress />
          ) : (
            <Feedback feedback={feedback} readOnly />
          )}
          {rating_criteria?.length === 0 ? (
            <Ratings
              rating_criteria={rating_criteria}
              stillInProgress
              globalRatingCriteria={globalRatingCriteria}
            />
          ) : (
            <Ratings rating_criteria={rating_criteria} onlyRead />
          )}
        </div>
      </div>
      <div className={classes.transcriptionContainer}>
        <PublicTranscription
          assignment_uuid={assignment_uuid}
          scenario_uuid={selectedScenario?.uuid}
          response_uuid={selectedScenario?.response?.uuid}
          clientName={AIprospect?.name}
          assigned_by_user={assigned_by_user}
          client_profile_pic={AIprospect?.profile_pic}
        />
      </div>
    </div>
  );
};

export default OldViewResults;

const formatDate = () => {
  const dateString = new Date();

  let month = dateString.getUTCMonth() + 1;
  if (month < 10) month = `0${month}`;
  let day = dateString.getUTCDate();
  if (day < 10) day = `0${day}`;
  let year = dateString.getUTCFullYear();

  const newDate = day + '-' + month + '-' + year;
  return newDate;
};